import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "uk-text-large" }
const _hoisted_2 = {
  key: 0,
  class: "uk-margin-remove"
}
const _hoisted_3 = { class: "uk-margin-remove" }
const _hoisted_4 = { class: "uk-margin-remove-top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.name)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.name), 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.addressLine2(_ctx.address)), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.addressLine3(_ctx.address)), 1)
  ]))
}